"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function toPrimitive(x) {
    // TODO(arjun): This isn't exactly the right order.
    if (typeof x === 'object' && x !== 'null') {
        let v = x.valueOf();
        if (typeof v === 'object' && v !== 'null') {
            v = x.toString();
            if (typeof v === 'object' && v !== 'null') {
                return undefined;
            }
            return v;
        }
        return v;
    }
    return x;
}
function toKey(x) {
    const r = toPrimitive(x);
    if (typeof r === 'string' || typeof r === 'number') {
        return r;
    }
    else {
        return String(r);
    }
}
exports.toKey = toKey;
function add(x, y) {
    return toPrimitive(x) + toPrimitive(y);
}
exports.add = add;
function mul(x, y) {
    return toPrimitive(x) * toPrimitive(y);
}
exports.mul = mul;
function sub(x, y) {
    return toPrimitive(x) - toPrimitive(y);
}
exports.sub = sub;
function div(x, y) {
    return toPrimitive(x) / toPrimitive(y);
}
exports.div = div;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW1wbGljaXRBcHBzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3J1bnRpbWUvaW1wbGljaXRBcHBzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBRUEsU0FBUyxXQUFXLENBQUMsQ0FBTTtJQUMxQixtREFBbUQ7SUFDbEQsSUFBSSxPQUFPLENBQUMsS0FBSyxRQUFRLElBQUksQ0FBQyxLQUFLLE1BQU0sRUFBRTtRQUN6QyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUMsT0FBTyxFQUFFLENBQUM7UUFDcEIsSUFBSSxPQUFPLENBQUMsS0FBSyxRQUFRLElBQUksQ0FBQyxLQUFLLE1BQU0sRUFBRTtZQUN6QyxDQUFDLEdBQUcsQ0FBQyxDQUFDLFFBQVEsRUFBRSxDQUFDO1lBQ2pCLElBQUksT0FBTyxDQUFDLEtBQUssUUFBUSxJQUFJLENBQUMsS0FBSyxNQUFNLEVBQUU7Z0JBQ3pDLE9BQU8sU0FBUyxDQUFDO2FBQ2xCO1lBQ0QsT0FBTyxDQUFDLENBQUM7U0FDVjtRQUNELE9BQU8sQ0FBQyxDQUFDO0tBQ1Y7SUFDRCxPQUFPLENBQUMsQ0FBQztBQUNYLENBQUM7QUFFRCxTQUFnQixLQUFLLENBQUMsQ0FBTTtJQUMxQixNQUFNLENBQUMsR0FBRyxXQUFXLENBQUMsQ0FBQyxDQUFDLENBQUM7SUFDekIsSUFBSSxPQUFPLENBQUMsS0FBSyxRQUFRLElBQUksT0FBTyxDQUFDLEtBQUssUUFBUSxFQUFFO1FBQ2xELE9BQU8sQ0FBQyxDQUFDO0tBQ1Y7U0FDSTtRQUNILE9BQU8sTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFDO0tBQ2xCO0FBQ0gsQ0FBQztBQVJELHNCQVFDO0FBRUQsU0FBZ0IsR0FBRyxDQUFDLENBQU0sRUFBRSxDQUFNO0lBQ2hDLE9BQVksV0FBVyxDQUFDLENBQUMsQ0FBQyxHQUFRLFdBQVcsQ0FBQyxDQUFDLENBQUMsQ0FBQztBQUNuRCxDQUFDO0FBRkQsa0JBRUM7QUFFRCxTQUFnQixHQUFHLENBQUMsQ0FBTSxFQUFFLENBQU07SUFDaEMsT0FBWSxXQUFXLENBQUMsQ0FBQyxDQUFDLEdBQVEsV0FBVyxDQUFDLENBQUMsQ0FBQyxDQUFDO0FBQ25ELENBQUM7QUFGRCxrQkFFQztBQUVELFNBQWdCLEdBQUcsQ0FBQyxDQUFNLEVBQUUsQ0FBTTtJQUNoQyxPQUFZLFdBQVcsQ0FBQyxDQUFDLENBQUMsR0FBUSxXQUFXLENBQUMsQ0FBQyxDQUFDLENBQUM7QUFDbkQsQ0FBQztBQUZELGtCQUVDO0FBRUQsU0FBZ0IsR0FBRyxDQUFDLENBQU0sRUFBRSxDQUFNO0lBQ2hDLE9BQVksV0FBVyxDQUFDLENBQUMsQ0FBQyxHQUFRLFdBQVcsQ0FBQyxDQUFDLENBQUMsQ0FBQztBQUNuRCxDQUFDO0FBRkQsa0JBRUMifQ==


//////////////////
// WEBPACK FOOTER
// .-continuations-compiler/dist/src/runtime/implicitApps.js
// module id = 823
// module chunks = 0